module.exports = __webpack_public_path__ + "img/folder-check.4b069841.svg";